import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, renderList as _renderList, renderSlot as _renderSlot, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ml-30" }
const _hoisted_2 = { class: "mb-x2" }
const _hoisted_3 = { class: "block font-bold" }
const _hoisted_4 = {
  key: 0,
  class: "block"
}
const _hoisted_5 = { class: "block" }
const _hoisted_6 = { class: "block" }
const _hoisted_7 = { class: "table" }
const _hoisted_8 = { class: "capitalize table-cell pr-x1" }

import {
    ParcelShopModel,
} from '@/storecontext/shared/api/server-apis';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import CheckoutPickAndPackParcelShopSkeleton from '@/storecontext/checkout/ui/deliverables/pick-and-pack/CheckoutPickAndPackParcelShopSkeleton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutPickAndPackParcelShopInfo',
  props: {
    parcelShop: null,
    showLoading: { type: Boolean }
  },
  setup(__props: any) {



const labels = useBlockLabels();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.showLoading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(labels).pickAndPackDeliveredToAddressTitle), 1),
            (__props.parcelShop?.companyName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.parcelShop?.companyName), 1))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_5, [
              _createTextVNode(_toDisplayString(__props.parcelShop?.street), 1),
              (__props.parcelShop?.street2)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("span", _hoisted_6, _toDisplayString(__props.parcelShop?.postalCode) + " " + _toDisplayString(__props.parcelShop?.city), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.parcelShop?.openingHours, (day) => {
              return (_openBlock(), _createElementBlock("div", {
                key: day.dayOfWeek,
                class: "table-row"
              }, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(day.dayOfWeek) + ":", 1),
                _createTextVNode(" " + _toDisplayString(day.openFrom) + " - " + _toDisplayString(day.openTo), 1)
              ]))
            }), 128))
          ]),
          _renderSlot(_ctx.$slots, "default")
        ], 64))
      : (_openBlock(), _createBlock(CheckoutPickAndPackParcelShopSkeleton, { key: 1 }))
  ]))
}
}

})